import React from "react";
import './index.css'

const SkeletonSliderItem = () => {
    return (
        <div className="slider-ll">
            <div className="skeleton-game-image skeleton"></div>
            {/* Skeleton for game image */}
            <div className="skeleton-game-info">
                <div className="skeleton skeleton-game-title"></div>
            </div>
        </div>
    );
};
export default SkeletonSliderItem
